import React, { useState } from "react";
import Awardbutton from "./Awardbutton";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const Awards = () => {
  const [activeTab] = useState("awards");

  const selectedLang = useSelector((state) => state.language.selectedLang);

  const content = {
    English: {
      title: "Awards",
      breadcrumb: {
        home: 'HOME',
        page: 'AWARDS'
      },
    },
    मराठी: {
      title: "पुरस्कार",
      breadcrumb: {
        home: 'मुख्यपृष्ठ ',
        page: 'पुरस्कार'
      },
    }
  };

  const t = content[selectedLang];

  return (
    <div className="py-12" >
      {/* Title */}
      < div className="text-center mb-8" >
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
          {t.title}
        </h1>
        <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
          <span style={{ color: "#DD9827" }}>
            <Link to="/" className="hover:underline">
              {t.breadcrumb.home}
            </Link>{" "}
            /{" "}
          </span>
          {t.breadcrumb.page}
        </p>
      </div >
      {/* <div className="flex justify-center gap-4 my-8 px-4 no-dark-bg">
        {categories.map((cat) => (
          <button
            key={cat.key}
            onClick={() => setActiveTab(cat.key)}
            className={`tab-button px-4 py-2 font-futura border rounded-md transition duration-300 ${activeTab === cat.key
                ? "active-tab"
                : "hover:bg-[#DD9827] hover:text-white border-[#DD9827]"
              }`}
          >
            {cat.label[selectedLang]}
          </button>
        ))}
      </div> */}
      {activeTab === "awards" && <Awardbutton />}
      {/* {activeTab === "scholarship" && <Scholarshipbutton />} */}
    </div >
  );
};

export default Awards;
